import { endBracket, startBracket } from "../validationRegex";

export const decodeComponentId = (componentId: string): string =>
  componentId.replace(startBracket, "").replace(endBracket, "");
